import { ListItemIcon, makeStyles, MenuItem } from '@material-ui/core'
import { MenuItemProps } from '@material-ui/core/MenuItem'
import { Theme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { ReactElement, useCallback } from 'react'

import ExitIcon from '@material-ui/icons/PowerSettingsNew'
import classnames from 'classnames'
import { useLogout, useTranslate } from 'ra-core'

interface Props {
  className?: string
  redirectTo?: string
  icon?: ReactElement
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    menuItem: {
      color: theme.palette.text.secondary,
    },
    icon: { minWidth: theme.spacing(5) },
  }),
  { name: 'RaLogout' }
)

/**
 * Logout button component, to be passed to the Admin component
 *
 * Used for the Logout Menu item in the sidebar
 */
const LogoutWithRef = React.forwardRef<
  HTMLLIElement,
  Props & MenuItemProps<'li', { button: true }> // HACK: https://github.com/mui-org/material-ui/issues/16245
>(function Logout(props, ref) {
  const { className, classes: classesOverride, redirectTo, icon, ...rest } = props
  const classes = useStyles(props)
  const translate = useTranslate()
  const logout = useLogout()

  const handleClick = useCallback(() => logout({ reason: 'logout-menu-item' }, redirectTo), [redirectTo, logout])
  return (
    <MenuItem className={classnames('logout', classes.menuItem, className)} onClick={handleClick} ref={ref} {...rest}>
      <ListItemIcon className={classes.icon}>{icon ? icon : <ExitIcon />}</ListItemIcon>
      {translate('ra.auth.logout')}
    </MenuItem>
  )
})

LogoutWithRef.propTypes = {
  className: PropTypes.string,
  redirectTo: PropTypes.string,
  icon: PropTypes.element,
}

export default LogoutWithRef
